module.exports = __webpack_public_path__ + "static/media/feat-tcr-img2.fbd16654.jpg";